import { render, staticRenderFns } from "./dev-online-list.vue?vue&type=template&id=45a40340&"
import script from "./dev-online-list.vue?vue&type=script&lang=js&"
export * from "./dev-online-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports